import { schema, types } from 'papr'

export const redirectionUrlSchema = schema({
	post: types.objectId({ required: true }),
	publication: types.objectId({ required: true }),
	/**
	 * The old slug of the post.
	 */
	slug: types.string({ required: true }),
})

export type RedirectionUrlDocument = (typeof redirectionUrlSchema)[0]
export type RedirectionUrlSchemaOptions = (typeof redirectionUrlSchema)[1]
